import React from 'react';
import styled from 'styled-components';

import InputGroupElement from '~/components/Inputs/InputGroupElement';
import TEST_ID from './ErrorLabel.testid';

type Props = {
  children: string;
};
const ErrorLabel = ({ children }: Props) => (
  <Container data-testid={TEST_ID.CONTAINER}>{children}</Container>
);

const Container = styled.div<{}>`
  ${({ theme }) => `
    color: ${theme.color('danger')};
  `}
`;

export default InputGroupElement(ErrorLabel, 'align-self: center');
